// components/ProjectMenu.jsx
import React, { useState, useRef, useEffect } from "react";
import { FaEllipsisH } from "react-icons/fa";
import s from "../styles/ProjectMenu.module.css";

const ProjectMenu = ({ onEdit, onDelete, onRerait, onAutoload, adsEdit }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={s.menuWrapper} ref={menuRef}>
      <button className={s.menuButton} onClick={() => setMenuOpen(!menuOpen)}>
        <FaEllipsisH />
      </button>

      {menuOpen && (
        <div className={s.dropdown}>
          <div className={s.item} onClick={() => { onEdit(); setMenuOpen(false); }}>
            ✏️ Редактировать
          </div>
          <div className={s.item} onClick={() => { onRerait?.(); setMenuOpen(false); }}>
            🔁 Авто переопубликация
          </div>
          <div className={s.item} onClick={() => { onAutoload?.(); setMenuOpen(false); }}>
            ⬆️ Автозагрузка Avito
          </div>
          <div className={s.item} onClick={() => { adsEdit?.(); setMenuOpen(false); }}>
            📦 Объявления
          </div>
          <div className={s.item} onClick={() => { onDelete(); setMenuOpen(false); }}>
            🗑️ Удалить
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectMenu;
